var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStatisticsAnalytics = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.3,
  d: "M1.75 8.007c.475 0 .932-.189 1.268-.525l.964-.964a1.8 1.8 0 0 1 1.267-.525v0c.476 0 .932.19 1.268.525l.964.964c.336.336.792.525 1.268.525v0c.475 0 .931-.189 1.267-.525l.965-.964a1.8 1.8 0 0 1 1.267-.525v0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.3,
  d: "M10.383 12.25H3.617a1.867 1.867 0 0 1-1.867-1.867V3.617c0-1.031.836-1.867 1.867-1.867h6.766c1.031 0 1.867.836 1.867 1.867v6.766c0 1.031-.836 1.867-1.867 1.867",
  clipRule: "evenodd"
})));
export default SvgStatisticsAnalytics;